<template>
  <article class="con_wrap">
    <!-- 日历 -->
    <div class="top_list">
      <div class="list_text" @click="dialogVisible">
        <i></i>
        <span>{{regularDate}}</span>
        <i class="iconfont">&#xe616;</i>
      </div>
      <transition name="calendar-fade">
        <keep-alive>
          <date-picker v-if="datePickerShow" @close="datePickerShow = false" v-model="regularDate"></date-picker>
        </keep-alive>
      </transition>
    </div>
    <div class="report_item_wrapper">
      <div class="report_header">
        <div class="item_title">
          <i class="iconfont">&#xe6ce;</i>
          <span>{{$t('tag.xindian.title')}}</span>
          <span class="srart_end_time"></span>
        </div>
        <div class="others"></div>
      </div>
      <div v-show="ecgShow">
        <v-ecg
          v-for="(item, index) in list"
          :ecgdata="item.ecg"
          :key="index"
          :heart="item.heart"
          :ox="item.ox"
          :af="item.af"
          :time="item.time"
          :id="index"
        ></v-ecg>
        <div class="read part-top">
          <div class="header">
            <i class="iconfont">&#xe61d;</i>
            <h2>{{$t('title.secondaryTitle.xindianReport')}}</h2>
          </div>
          <div class="content">
            <div :class="['article',contentShow ? 'show' : 'hidden']">
              <!--  v-for="(item,index) in content" :key="index" -->
              <p>{{content}}</p>
            </div>
            <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
              <i class="iconfont" v-show="!contentShow">&#xe632;</i>
              <i class="iconfont" v-show="contentShow">&#xe633;</i>
            </div>
          </div>
        </div>
      </div>

      <div class="noEcgChart" v-show="!ecgShow">
        <p>
          <strong>{{regularDate}}</strong>
          {{$t('tag.xindian.text')}}
        </p>
      </div>
    </div>
  </article>
</template>
<script>
import item from "./item.vue";
import datePicker from "./datePicker";
export default {
  name: "heartEcg",
  props: {
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      datePickerShow: false,
      regularDate: "",
      ecgShow: true,
      content: this.$t("ecg.current"),
      contentShow: false,
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    // this.getCurrentDataInfo()
    this.newdate();
  },
  methods: {
    dialogVisible() {
      this.datePickerShow = true;
    },
    newdate() {
      let dt = new Date();
      let y = dt.getFullYear();
      let m = dt.getMonth() + 1;
      let d = dt.getDate();
      m = m > 9 ? m : "0" + m;
      this.regularDate = y + "-" + m + "-" + d;
      // console.log(this.regularDate);
    },
    getCurrentDataInfo() {
      let postData = {
        date: this.regularDate,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token,
        current: this.current
      };
      this.$axios
        .getEcg(this.appType, postData)
        .then(this.getCurrentDataInfoSucc);
    },
    getCurrentDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.ecgShow = true;
        const data = res.data;
        this.list = data;
        // console.log(this.list);
      } else if (res.code === 999) {
        this.ecgShow = false;
      }
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    }
  },
  components: {
    "v-ecg": item,
    datePicker
  },
  watch: {
    regularDate: function() {
      this.getCurrentDataInfo();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl';

.con_wrap {
  width: 100%;
  height: 100%;

  .top_list {
    width: 95%;
    font-size: 0.3rem;
    color: #128f50;
    box-sizing: border-box;
    padding: 0.3rem 0.86rem;
    margin: 0 auto 0.26rem auto;
    box-shadow: 0 3px 8px rgba(53, 150, 234, 0.27);
    border-radius: 0.1rem;
    background-color: #fff;

    .list_text {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 0.3rem;
        font-weight: bold;
      }

      .iconfont {
        font-size: 0.4rem;
      }
    }
  }

  .report_item_wrapper {
    .report_header .item_title .iconfont {
      color: $blueText;
    }

    .noEcgChart {
      margin: 0.4rem 0;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-size: 0.32rem;

        strong {
          font-weight: bold;
        }
      }
    }
  }
}

.read {
  .content {
    position: relative;
    padding: 0 0 0.2rem 0;
    line-height: 0.55rem;

    .mask {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.7rem;

      &.hidden {
        background: rgba(255, 255, 255, 0.9);
      }

      &.show {
        background: rgba(255, 255, 255, 1);
      }

      .iconfont {
        margin-top: 0.02rem;
        display: block;
        font-size: 0.48rem;
        color: #333;
      }
    }

    h3 {
      margin-bottom: 0.1rem;
      font-size: 0.3rem;
      font-weight: bold;
    }

    .article {
      text-indent: 0.6rem;
      text-align: justify;
      color: #707070;

      &.hidden {
        height: 1.4rem;
        overflow: hidden;
      }

      &.show {
        margin-bottom: 0.7rem;
        height: auto;
        overflow: auto;
      }
    }
  }
}

.part-top {
  margin: 0.6rem 0 0.4rem;

  .header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 0.2rem;

    .iconfont {
      margin: 0 0.1rem 0;
      font-size: 0.4rem;
      color: $blueText;
    }

    h2 {
      font-size: 0.36rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ecg/ecg.vue